/* eslint-disable max-len */
import * as yup from 'yup';

export const initialFlowState = {
  isLoading: true,
  isSuccess: '',
  largeImageMessage: '',
  isImageViewOpen: false,
  isButtonLoading: false,
  imageSrcForAction: '',
  isDeleteModalOpen: false,
}

export const initialFormState = {
  iceCream: false,
  pastry: false,
  pudding: false,
  latitude: '',
  longitude: '',
  marketId: '',
  visible: true
}

export const createMarkSchema = yup.object().shape({
  latitude: yup.string().required(),
  longitude: yup.string().required(),
  iceCream: yup.boolean().required(),
  pastry: yup.boolean().required(),
  pudding: yup.boolean().required(),
  visible: yup.boolean().required(),
  marketId: yup.string().optional(),
});
